<template>
    <v-container fluid>
        <rule-form
            :model="model"
            :titlePrefix="$t('forms.title_prefix.add')"
            @saved="saved"
        />
    </v-container>
</template>

<script>
import RuleForm from './Form'
import Rule from '@/models/Rule'
import CycleRule from '@/models/CycleRule'

export default {
    components: {
        RuleForm,
    },

    computed: {
        isCycleRule() {
            return (
                this.$route.query.cycle_rule === 'true' ||
                this.$route.query.cycle_rule === '1'
            )
        },

        model() {
            return this.isCycleRule ? new CycleRule() : new Rule()
        },
    },

    methods: {
        saved() {
            this.$router.go(-1)
        },
    },
}
</script>

<style></style>
